import React from "react";
import { currencyFormatterFractionsIfNeeded } from "@common/helpers/currency";

interface Props {
    filters: {
        minAmount?: number;
        maxAmount?: number;
    };
}

export const AmountFilterLabel: React.FC<Props> = ({
    filters: { minAmount, maxAmount },
}) => {
    if (minAmount !== undefined && maxAmount !== undefined) {
        if (minAmount === maxAmount) {
            return <>{currencyFormatterFractionsIfNeeded.format(minAmount)}</>;
        }

        return (
            <>
                {currencyFormatterFractionsIfNeeded.format(minAmount)} -{" "}
                {currencyFormatterFractionsIfNeeded.format(maxAmount)}
            </>
        );
    }

    if (minAmount !== undefined) {
        return <>≥ {currencyFormatterFractionsIfNeeded.format(minAmount)}</>;
    }

    if (maxAmount !== undefined) {
        return <>≤ {currencyFormatterFractionsIfNeeded.format(maxAmount)}</>;
    }

    return null;
};
